'use client';

import { TheBoatAppLandingConfigType, useConfig } from '@marine/configs';
import { FC } from 'react';
import { SanityImage } from 'sanity-image';
import { SanityImageAssetReference } from '../../../sanity_types/theboat_landing_types';

type Props = {
  image?: SanityImageAssetReference;
  altText: string;
};

const BlogDetailCoverImage: FC<Props> = ({ image, altText }) => {
  const { projectId, dataset } = useConfig<TheBoatAppLandingConfigType>();
  return (
    <SanityImage
      id={image?._ref ?? ''}
      projectId={projectId}
      dataset={dataset}
      width={1027}
      height={578}
      alt={altText}
    />
  );
};

export { BlogDetailCoverImage };
